import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
import icon_edit from '../../../assets/images/icon_edit.svg';

const EditDiagram = ({ x, y, numberKey, setNumberKey, setShow, setEdit }) => {
    const [image] = useImage(icon_edit);
    const showEditDiagram = async () => {
      await setNumberKey(numberKey);
      setShow(true);
      setEdit(true);
    };
    return (
      <Image
        x={x}
        y={y}
        width={20}
        height={20}
        image={image}
        onClick={showEditDiagram}
      />
    );
  };

export default EditDiagram;